import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_BIOMETRIA } from 'services/rotasp/path';

// ACTIONS
import { addNotifications } from 'store/modules/app/notifications/actions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, RequestVerificacoes } from './types';

// ACTIONS
import {
	confrontarDigitaisIIRGDSuccess,
	confrontarDigitaisIIRGDFailure,
} from './actions';

function* confrontarDigitaisIIRGDRequest(request: ReducerAction) {
	const { token, payload }: { token?: string; payload: RequestVerificacoes } =
		request;

	const body = {
		...payload,
		finalidade: 'REUSO_RG',
		tipo: 'DIGITAL',
		tipoArquivo: 'IMAGEM',
		tipoTemplate: 'VERIFINGER',
	};

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_BIOMETRIA,
		`v3/verificacoes?rgSp=${body.rgSp}&dedo=${body.dedo}&finalidade=${body.finalidade}&tipo=${body.tipo}&tipoArquivo=${body.tipoArquivo}&tipoTemplate=${body.tipoTemplate}`,
		payload.digital,
		{ 'Content-Type': 'application/octet-stream' },
	);

	if (response.status === 200) {
		if (
			response.data.resultado === true ||
			response.data.resultado === 'true'
		) {
			yield put(confrontarDigitaisIIRGDSuccess());
		} else {
			yield put(confrontarDigitaisIIRGDFailure());
			addNotifications({
				errors: [
					'A conferência da biometria falhou. Realize o procedimento novamente.',
				],
			});
		}
	} else {
		yield put(confrontarDigitaisIIRGDFailure());
		addNotifications({
			errors: [
				'A conferência da biometria falhou. Realize o procedimento novamente.',
			],
		});
	}
}

export default all([
	takeLatest(
		Types.CONFRONTAR_DIGITAIS_IIRGD_REQUEST,
		confrontarDigitaisIIRGDRequest,
	),
]);
